import React, {Component} from 'react';
import Container from 'react-bootstrap/Container'
import {Navbar, Nav} from 'react-bootstrap'

class BarraNavigazione extends Component {
    render() {
        const isExternalLink = /^https?:\/\//.test(this.props.linkSito);

        return (
			<Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
				<Container>
					<Navbar.Brand
						className="logo-azienda verso-brand"
						href={this.props.linkSito}
						target={isExternalLink ? "_blank" : undefined}
						rel={isExternalLink ? "noreferrer noopener" : undefined}
					>
						<img className="verso-brand-logo" src={this.props.logo} alt={this.props.deskLogo} />
						{this.props.brandName ? (
							<span className="verso-brand-name">{this.props.brandName}</span>
						) : null}
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="responsive-navbar-nav" />
					<Navbar.Collapse id="responsive-navbar-nav">
						<Nav className="me-auto"></Nav>
						<Nav>
							{this.props.aNavbarLinks.map((link) => (
								<Nav.Link key={link.id} href={link.linkHref}>{link.linkNome}</Nav.Link>
							))}
							<Nav.Link className="vh-cookie-menu-link" href="/cookies#preferenze" data-cookie-preferences="true">PREFERENZE COOKIE</Nav.Link>
						</Nav>
					</Navbar.Collapse>
				</Container>
			</Navbar>
			
        );
    }

}

export default BarraNavigazione;


